<app-life-ins-headline [maInsuranceExtend]="maInsuranceExtend"></app-life-ins-headline>
<div class="life-ins__content">
    <div nxRow>
        <div nxCol="12,12,12,4">
            <app-life-ins-date [maInsuranceExtend]="maInsuranceExtend"></app-life-ins-date>
        </div>
        <div nxCol="12,12,12,4">
            <div class="check-label">
                <cpc-icon icon="check" [color]="'#70ad47'"></cpc-icon>
                {{ maInsuranceExtend.tariffDescShort }}
            </div>
        </div>
        <div nxCol="12,12,12,4">
            <div nxRow class="pair-column">
                <div nxCol="6">{{ 'ma-insurance.life.sumInsured' | translate }}</div>
                <div nxCol="6">{{ maInsuranceExtend.sumInsured|currencyFormat }}</div>
            </div>
            <div nxRow class="pair-column">
                <div nxCol="6">{{ 'ma-insurance.life.address' | translate }}</div>
                <div nxCol="6">{{ maInsuranceExtend.address }}</div>
            </div>
        </div>
    </div>

    <div nxRow>
        <div nxCol="12" class="agent-text">
            <p nxCopytext class="nx-margin-bottom-2m">{{ 'ma-insurance.life.houseHoldText' | translate }}</p>
            <ul>
                <li>{{ 'ma-insurance.life.houseHoldTextAgent' | translate }} <span *ngIf="agent">{{ agent.agentName }},
                        {{ agent.agentMobilAgn}}</span></li>
                <li>{{ 'ma-insurance.life.houseHoldTextRequest' | translate }}<nx-link><a
                            [routerLink]="['/inbox/napiste-nam']">online</a>
                    </nx-link></li>
            </ul>
        </div>
    </div>
</div>